import { api } from "./apiClient";

const platformAPI = {
  getPublicPlans() {
    return api
      .get("/platform/public/plans", { skipTenant: true })
      .then((r) => r.data);
  },
  getFeaturesCatalog() {
    return api.get("/platform/features").then((r) => r.data);
  },
  getAnalytics() {
    return api.get("/platform/analytics").then((r) => r.data);
  },
  getAuditLogs(limit = 50) {
    return api
      .get("/platform/audit-logs", { params: { limit } })
      .then((r) => r.data);
  },
  getPlans() {
    return api.get("/platform/plans").then((r) => r.data);
  },
  createPlan(body) {
    return api.post("/platform/plans", body).then((r) => r.data);
  },
  updatePlan(id, body) {
    return api.patch(`/platform/plans/${id}`, body).then((r) => r.data);
  },
  deletePlan(id) {
    return api.delete(`/platform/plans/${id}`).then((r) => r.data);
  },
  getClinics() {
    return api.get("/platform/clinics").then((r) => r.data);
  },
  getClinic(id) {
    return api.get(`/platform/clinics/${id}`).then((r) => r.data);
  },
  updateClinicStatus(id, status) {
    return api.patch(`/platform/clinics/${id}`, { status }).then((r) => r.data);
  },
  updateClinicBilling(id, body) {
    return api
      .patch(`/platform/clinics/${id}/billing`, body)
      .then((r) => r.data);
  },
  getClinicSubscriptionCheckout(id, params) {
    return api
      .get(`/platform/clinics/${id}/billing/checkout`, { params })
      .then((r) => r.data);
  },
  initClinicSubscriptionPayment(id, body) {
    return api
      .post(`/platform/clinics/${id}/billing/pay/init`, body)
      .then((r) => r.data);
  },
  listClinicUsers(id, params = {}) {
    return api
      .get(`/platform/clinics/${id}/users`, { params })
      .then((r) => r.data);
  },
  deleteClinicUser(clinicId, userId) {
    return api
      .delete(`/platform/clinics/${clinicId}/users/${userId}`)
      .then((r) => r.data);
  },
  deleteClinic(id) {
    return api
      .delete(`/platform/clinics/${id}`, { timeout: 30000 })
      .then((r) => r.data);
  },
  listSupportThreads() {
    return api.get("/platform/support/threads").then((r) => r.data);
  },
  startSupportThread(body) {
    return api.post("/platform/support/start", body).then((r) => r.data);
  },
  getSupportUnread() {
    return api.get("/platform/support/unread").then((r) => r.data);
  },
  getSupportThreadMessages(threadKey, params) {
    return api
      .get(`/platform/support/threads/${encodeURIComponent(threadKey)}/messages`, {
        params,
      })
      .then((r) => r.data);
  },
  sendSupportReply(threadKey, body) {
    return api
      .post(
        `/platform/support/threads/${encodeURIComponent(threadKey)}/messages`,
        body,
      )
      .then((r) => r.data);
  },
  editSupportMessage(threadKey, messageId, body) {
    return api
      .patch(
        `/platform/support/threads/${encodeURIComponent(threadKey)}/messages/${encodeURIComponent(messageId)}`,
        body,
      )
      .then((r) => r.data);
  },
  deleteSupportMessage(threadKey, messageId) {
    return api
      .delete(
        `/platform/support/threads/${encodeURIComponent(threadKey)}/messages/${encodeURIComponent(messageId)}`,
      )
      .then((r) => r.data);
  },
  uploadSupportMedia(file) {
    const form = new FormData();
    form.append("file", file);
    return api
      .post("/platform/support/upload", form, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 180000,
      })
      .then((r) => r.data);
  },
  listPayments(params = {}) {
    return api.get("/platform/payments", { params }).then((r) => r.data);
  },
  getPaymentsStats() {
    return api.get("/platform/payments/stats").then((r) => r.data);
  },
  listNotifications(params = {}) {
    return api.get("/platform/notifications", { params }).then((r) => r.data);
  },
  getNotificationsUnread() {
    return api.get("/platform/notifications/unread").then((r) => r.data);
  },
  markNotificationRead(id) {
    return api
      .post(`/platform/notifications/${id}/read`)
      .then((r) => r.data);
  },
  markAllNotificationsRead() {
    return api.post("/platform/notifications/read-all").then((r) => r.data);
  },
  listLeads(params = {}) {
    return api.get("/platform/leads", { params }).then((r) => r.data);
  },
  getLeadStats() {
    return api.get("/platform/leads/stats").then((r) => r.data);
  },
  createLead(body) {
    return api.post("/platform/leads", body).then((r) => r.data);
  },
  updateLead(id, body) {
    return api.patch(`/platform/leads/${id}`, body).then((r) => r.data);
  },
  deleteLead(id) {
    return api.delete(`/platform/leads/${id}`).then((r) => r.data);
  },
  scrapeLeads(body) {
    return api
      .post("/platform/leads/scrape", body, { timeout: 120000 })
      .then((r) => r.data);
  },
  importLeads(body) {
    return api
      .post("/platform/leads/import", body, { timeout: 120000 })
      .then((r) => r.data);
  },
  getOnboardingEmailPreviews() {
    return api.get("/platform/leads/onboarding-emails").then((r) => r.data);
  },
};

export default platformAPI;
